import {
    getByIdTrackingRouteLoading,
    getByIdTrackingRouteSuccess,
    getByIdTrackingRouteReject,
    getByIdTrackingRouteRequest
} from "../../actions/home/getByIdOnRoute";

export const getIdOnRoutes = (formData) => async (dispatch, getState) => {
    dispatch(getByIdTrackingRouteLoading());
    try {
        const { data } = await getByIdTrackingRouteRequest(formData, getState);
        dispatch(getByIdTrackingRouteSuccess(data))
    } catch (error) {
        dispatch(getByIdTrackingRouteReject(error))
    }
    return Promise.resolve();
};

export const cleanDetailRoute = () => async (dispatch, getState) => {
    dispatch(getByIdTrackingRouteReject({}))
}